import React from 'react';

export function ChipComponent({
  className,
  style,
  label,
  selected,
  onClick
}) {
  const styles = {
    cursor: 'pointer',
    color: 'rgba(0, 0, 0, 0.87)',
    padding: '5px 12px',
    background: selected ? '#e1ffe3' : 'white',
    borderRadius: '16px',
    border: `1px solid ${selected ? '#43b549' : 'rgba(0, 0, 0, 0.23)'}`,
    whiteSpace: 'nowrap',
    ...style,
  }
  return (
    <div
      className={className}
      style={styles}
      onClick={onClick}
    >
      {label}
    </div>
  )
}